import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BibliographySetDetailBibliography {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  marcNo: string
  searchType: SystemCode
  displayMaterialFormat: SystemCode
  displayClass: string
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  publicationFrequency: SystemCode
  continuationStatus: SystemCode
  collectionFlag: CollectionFlag
  revision: number
}

export const defaultBibliographySetDetailBibliography = (): BibliographySetDetailBibliography => ({
  bibliographyClass: BibliographyClass.Set,
  prefix: Prefix.Set,
  bibliographyId: 0,
  marcNo: '',
  searchType: defaultSystemCode(),
  displayMaterialFormat: defaultSystemCode(),
  displayClass: '',
  displayTitle: '',
  displayAuthor: '',
  displayPublisher: '',
  publicationFrequency: defaultSystemCode(),
  continuationStatus: defaultSystemCode(),
  collectionFlag: null,
  revision: 0
})

export function BibliographySetDetailBibliographyFromJSON(
  json: any
): BibliographySetDetailBibliography {
  return {
    bibliographyClass: json.bibliography_class,
    prefix: json.prefix,
    bibliographyId: json.bibliography_id,
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    publicationFrequency: exists(json, 'publication_frequency')
      ? SystemCodeFromJSON(json.publication_frequency)
      : defaultSystemCode(),
    continuationStatus: exists(json, 'continuation_status')
      ? SystemCodeFromJSON(json.continuation_status)
      : defaultSystemCode(),
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : null,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
